<div class="card" (click)="onCardClick()">
  <div class="container">
    <div class="row">
<div class="d-flex align-items-center justify-content-between">
  <label class="card-title fw-semibold" id="schoolName">
    <span class="material-symbols-outlined" style="color: var(--green)">emoji_nature</span>
    {{ schoolName }}
  </label>
  <div class="d-inline-flex align-items-center">
      <span *ngIf="projectEmpty" class="badge bg-grey">Project Missing</span>
      <span *ngIf="!projectEmpty" class="badge bg-green" style="color: var(--darkerblue)">Project Exists</span>
  </div>
</div>
      <div class="col-12">
        <hr style="border: 1px solid black; width: 100%; margin-top:0;">
      </div>
        <div class="col-12">
          <b>GHS Representative: </b>{{ teacherName }}
        </div>
      <div class="col-12">
        <b>Year: </b>{{ year }}
      </div>
      <div class="col-12">
        <div id="fakeButton" class="d-flex justify-content-end text-primary mt-2">
          Click to see more details &#8594;
        </div>
      </div>
    </div>
  </div>
</div>



